.content {
  //max-height: 150px;
  overflow: hidden;
  position: relative;
  display: block;

  transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);
  max-height: 10000px;

  &:after {
    content: "";
    display: none;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100px;
  }
}

.button {
  display: none;
}

//

.active-mobile {
  @include media-breakpoint-down(sm) {
    .button {
      display: initial;
    }

    .content {
      background: transparent;
      max-height: var(--content-min-height);

      &:after {
        display: block;
      }
    }
  }
}

.active-tablet {
  @include media-breakpoint-only(md) {
    .button {
      display: initial;
    }

    .content {
      background: transparent;
      max-height: var(--content-min-height);

      &:after {
        display: block;
      }
    }
  }
}

.active-desktop {
  @include media-breakpoint-up(lg) {
    .button {
      display: initial;
    }

    .content {
      background: transparent;
      max-height: var(--content-min-height);

      &:after {
        display: block;
      }
    }
  }
}

.expanded {
  .content {
    max-height: 10000px !important;

    transition: max-height 1s ease-in-out;

    &:after {
      display: none;
    }
  }
}

.background-white {
  .content:after {
    background: linear-gradient(to top, c("white"), rgba(c("white"), 0.1));
  }
}

.background-gray {
  .content:after {
    background: linear-gradient(to top, c(neutral05), rgba(c(neutral05), 0.1));
  }
}

.background-css-variable {
  .content:after {
    background: linear-gradient(
      to top,
      var(--read-more-backgound),
      transparent
    );
  }
}
